<section class="login_full_dialog login-form">
  <div class="content height100vh" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start stretch">
    <div class="left-content loginLeft" fxLayout="column" fxFlex="50" fxFlex.lt-lg="50" fxFlex.xs="100">
            <div class="login-content login-second-content"  *ngIf="signInShow">
              <div class="title">
                <img src="../../../../../assets/images2/logo-login.svg" alt="img">
                <h2>login to your account</h2>
                
              </div>
        <form class="form-section" [formGroup]="loginForm" #contactClear="ngForm" (ngSubmit)="login()">
            <!--<div class="custom-form-group">
                <div class="custom-form-control">                   
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="type" placeholder="Select any type">
                      <mat-option disabled=""> Select any type </mat-option>
                      <mat-option [value]="'PRACTICE'">Dental Practice Owner</mat-option>
                      <mat-option [value]="'PROFESSIONAL'">Dental Professional</mat-option>
                      <mat-option [value]="'SUPPLIER'">Dental Business Partners</mat-option>
                      <mat-option [value]="'ADMIN'">Admin</mat-option>
                    </mat-select>                   
                  </mat-form-field>
                  <div class="errorMsg" *ngIf="loginForm.get('type')?.invalid && (loginForm.get('type')?.dirty || loginForm.get('type')?.touched) && submitted">
                    <span>Please provide a valid type</span>
                  </div>
                </div>
            </div>-->
            <div class="custom-form-group">
                <div class="custom-form-control">
                  <label>Email address</label>
                  <mat-form-field appearance="outline" floatLabel="never">
                 
                    <input type="email" matInput  placeholder="Enter your name"  formControlName="emailOrPhone">
                   
                  </mat-form-field>
                  <div class="errorMsg" *ngIf="emailOrPhone && emailOrPhone.invalid && ( emailOrPhone.dirty || emailOrPhone.touched) && submitted">
                    <span>Email is required</span>
                  </div>
                </div>
            </div>
            <div class="custom-form-group">
                <div class="custom-form-control">
                  <label>Password</label>
                    <mat-form-field appearance="outline" floatLabel="never">
          
                      <input [type]="passwordShow ? 'text' : 'password'" type="password" matInput
                      placeholder="Password" formControlName="password">                      
                    </mat-form-field>                   
                    <div class="errorMsg" *ngIf="password && password.invalid && ( password.dirty || password.touched ) && submitted">
                      <span>Password is required</span>
                    </div>
                </div>
            </div>
            <div class="forgot_password_flex">
              <div class="remember_checkbox">
                  <mat-checkbox>Remember me</mat-checkbox>
              </div>
              <a (click)="forgotPwd()">Forgot password?</a>
          </div>
          
            <div class="custom-form-group">
                <div class="custom-form-control btn-center">
                <!--  <button type="submit" mat-button class="btn-primary" (click)="login()">
                    <img src="../../../../../assets/images2/icons/orange-arrow.svg" alt="black-arrow">
                    Login
                </button>-->
                    <button type="submit" mat-button class=" global-btn" style="width:100%">
                       
                        Login
                    </button>
                </div>
            </div>
            <div class="loginOr">Or</div>
            <div class="donthave" style="display: flex; gap: 10px;" >
              <button type="button" mat-button class="global-btn-dark" (click)="goToSignUp($event)">
                
                Sign up with Google
                <img src="../../../../../assets/images2/icons/signup-google.svg" alt="black-arrow">
            </button>
            
            <button type="button" mat-button class="global-btn-dark" (click)="goToSignUp($event)">
              Sign up with Email
              <img src="../../../../../assets/images2/icons/signup-email.svg" alt="black-arrow">

          </button>
            </div>
        </form>

      
    </div>
    <div class="login-content login-second-content"  *ngIf="forgotPwdShow">

      <div class="title">
        <img src="../../../../../assets/images2/logo-login.svg" alt="img">
        <h2>Reset Password</h2>
        
      </div>
   
     
      <form [formGroup]="forgotPwdForm" class="form-section" (ngSubmit)="resetPassword()">
        <div class="fields_box">


          <div class="custom-form-group login_user_select">
            <!-- <label class="custom-label" for="" style="text-transform: initial;">I<span class="star">*</span></label> -->
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <mat-select formControlName="type" placeholder="Select any type">
                  <mat-option disabled=""> Select any type </mat-option>
                  <mat-option [value]="'PRACTICE'">Dental Practice Owner</mat-option>
                  <mat-option [value]="'PROFESSIONAL'">Dental Professional</mat-option>
                  <mat-option [value]="'SUPPLIER'">Dental Business Owner</mat-option>
                  <!-- <mat-option [value]="'ADMIN'">Admin</mat-option> -->
                </mat-select>
              </mat-form-field>
                <div class="errorMsg" *ngIf="forgotPwdForm.get('type')?.invalid && (forgotPwdForm.get('type')?.dirty || forgotPwdForm.get('type')?.touched || submitted)">
                  <span>Please provide a valid type</span>
                </div>
              
             
            </div>
          </div>

          <div class="custom-form-group">
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input type="email" matInput placeholder="Email address" formControlName="emailRec">
              </mat-form-field>
                <div class="errorMsg" *ngIf="forgotPwdForm.get('emailRec')?.invalid && (forgotPwdForm.get('emailRec')?.dirty || forgotPwdForm.get('emailRec')?.touched || submitted)">
                  <span>Email is required</span>
                </div>
         
            </div>
          </div>
          <!-- PASSWORD-INPUT -->
          <!-- <div class="custom-form-group">
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input [type]="passwordShow ? 'text' : 'password'" type="password" matInput
                  placeholder="Enter Password" formControlName="passWord">
                <mat-error *ngIf="passWord.invalid && ( passWord.dirty || passWord.touched )">
                  <span>Password is required</span>
                </mat-error>
                <span class="view-password" (click)="viewPassword()" matSuffix>
                  <img src="../../../../../assets/images/icons/icon_edb_hide.svg" alt="img" loading="lazy"
                    *ngIf="!passwordShow">
                  <img src="../../../../../assets/images/icons/icon_edb_view.svg" alt="img" loading="lazy"
                    *ngIf="passwordShow">
                </span>
              </mat-form-field>
            </div>
          </div> -->
          <!-- PASSWORD-INPUT -->
          <!-- <div class="custom-form-group">
            <div class="custom-form-control">
              <mat-form-field appearance="outline">
                <input [type]="passwordShow ? 'text' : 'password'" type="password" matInput
                  placeholder="Enter Password" formControlName="confPassword">
                <mat-error *ngIf="confPassword.invalid && ( confPassword.dirty || confPassword.touched )">
                  <span>Confirm password is required</span>
                </mat-error>
                <span class="view-password" (click)="viewPassword()" matSuffix>
                  <img src="../../../../../assets/images/icons/icon_edb_hide.svg" alt="img" loading="lazy"
                    *ngIf="!passwordShow">
                  <img src="../../../../../assets/images/icons/icon_edb_view.svg" alt="img" loading="lazy"
                    *ngIf="passwordShow">
                </span>
              </mat-form-field>
            </div>
          </div> -->
          <div class="forgot_password" style="margin-bottom: 10px;">
            <span  >Continue to </span>
            <a class="primary" (click)="logIn()">Login</a>
          </div>
        </div>
        <div class="custom-form-group">
          <div class="custom-form-control btn-center">
            <button type="submit" mat-button class=" global-btn" style="width:100%" >
                       
               Reset Password
          </button>
 
          </div>
      </div>
       
      </form>
    </div>
  </div>
    <div class="right-img" fxLayout="column" fxFlex="55" fxFlex.lt-lg="50" fxFlex.xs="100">
      <div class="rent-img">
        <img src="../../../../../assets/images2/login.png" class="rent-form-img" alt="contact-form-img">
      </div>
    </div>
</div>
  <div class="modal_close_btn">
    <span mat-dialog-close class="modal-close"><i class="material-icons">close</i></span>
  </div>


</section>
